import React, { Component } from "react";

import './Contact.css';
import { render } from "@testing-library/react";

import Typewriter from 'typewriter-effect';
import Clock from 'react-live-clock';
import Delayed from "../Delayed";


class Contact extends Component {
  constructor() {
    super();
    this.state = {
      name: "Vinayak Goswami",
    };
  }

  render(){
    return(
      <div>

        <h1>
          vinayak@goswami:$
        </h1>

        <div className="scrollable-div">
          <Typewriter
            onInit={(typewriter) => {
              typewriter
                .typeString('<span style="color:#52a563;">❯</span>  ')
                .pauseFor(1500)
                .typeString('cat contact_me.txt')
                .pauseFor(300)
                .typeString('<br><br>')
                .pasteString('<h3> You can contact me at my email:</h3>')
                .pasteString('<br> <a href="mailto:vinayakg.co18@nsut.ac.in" class = "linkr"><i class="fa fa-envelope"></i> vinayakg.co18@nsut.ac.in</a>')
                .pauseFor(300)
                .typeString('<br><br>')
                .pasteString('<h3> Alternatively you can reachout to me at LinkedIn</h3>')
                .pasteString('<br> <a href="https://www.linkedin.com/in/vinayak-goswami/" class = "linkr"><i class="fa fa-linkedin-square"></i> LinkedIn - Vinayak Goswami</a>')
                .start();
            }}
          />
        </div>
      
      </div>

    );
  }
}

export default Contact;
